import React from 'react';
import Message from 'components/Message';
import Isvg from 'react-inlinesvg';
import { ICONS } from 'constants/icons';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'opportunities.empty.header',
    defaultMessage: 'You’re all set.',
  },
  body: {
    id: 'opportunities.empty.biline',
    defaultMessage: 'Please check back later for more recommendations.',
  },
});

const Empty = () => (
  <div className="opportunities__empty">
    <div className="opportunities__checkmark">
      <Isvg src={ICONS.checkmark} />
    </div>
    <Message className="mb-s" as="h5" message={messages.title} />
    <Message className="mb-0 text--light text--center" as="p" message={messages.body} />
  </div>
);

export default Empty;
